<template>
  <div>
    <el-drawer title="添加出库计划" direction="ltr" :visible.sync="addPlanTwoVisible" :before-close="addPlanClose" size="58%">
      <div style="margin-left:10px;">
        <p>人车信息 </p>
        <hr>
        <el-table max-height="300px" border bordersize="mini" size="mini" ref="tabref" :data="subTableData"
          style="width:100%" highlight-current-row :header-cell-style="{ background: '#F5F5F5', color: 'black' }">
          <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
          <el-table-column prop="plateNumber" label="提货车号" width="150">
            <template slot="header">
              <div><span class="red">*</span>提货车号</div>
            </template>
            <template slot-scope="scope">
              <el-select clearable @change="plateNumChange(scope.row, scope.row.plateNumber)"
                v-model="scope.row.plateNumber" size="mini" placeholder="请选择" allow-create filterable>
                <el-option v-for="(item, index) in plateNumberOption" :key="index" :label="item.plateNumber"
                  :value="item.plateNumber"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="driverName" label="司机姓名" width="130">
            <template slot="header">
              <div><span class="red">*</span>司机姓名</div>
            </template>
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.driverName" placeholder="请输入司机姓名"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="idNumber" label="司机身份证号">
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.idNumber" placeholder="请输入司机身份证号"
                @blur="idInput(scope.row.idNumber)"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="telephone" label="联系电话">
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.telephone" placeholder="请输入司机联系电话"
                @blur="phoneInput(scope.row.telephone)"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin:20px 0 30px 0;" v-for="(item, ix) in allDataList" :key="ix">
          <p>货物信息</p>
          <hr>
          <div>
            <div style="display: flex;justify-content: space-between;">
              <div style="display: flex;margin-bottom:10px;">
                <!-- <div>{{(item.cargoControlKey).replace(/,/g,"/")}}</div>-->
                <div style="display: flex;">
                  <span style="margin-left:20px;">合计：</span>
                  <div>
                    <span style="color:red">{{ item.sumWeight }}</span><span> 吨 </span>
                    <span> / </span><span style="color:red">{{ item.num }}</span><span> 件</span>
                  </div>
                </div>
                <div style="display: flex;" v-if="item.surplus">
                  <span style="margin-left:20px;">货权剩余：</span>
                  <div>
                    <span v-if='item.controlWeight == 1'><span style="color:red">{{ item.surplusControlWeight
                    }}</span><span> 吨</span></span>
                    <span v-if='item.controlPiece == 1'><span> / </span><span style="color:red">{{
                      item.surplusControlNumber }}</span><span> 件</span></span>
                  </div>

                </div>
                <div style="margin-left:20px;">
                  <el-button type="primary" size="mini" @click="delClick(item, ix)">清空</el-button>
                </div>
              </div>

            </div>
          </div>
          <el-table max-height="300px" border bordersize="mini" size="mini" ref="tabref" :data="item.list"
            style="width:100%" highlight-current-row :header-cell-style="{ background: '#F5F5F5', color: 'black' }">
            <el-table-column type="index" prop="date" min-width="50" label="序号" align="center"></el-table-column>
            <el-table-column prop="number" align="center" label="操作"   width="50">
              <template slot-scope="scope1">
                <el-button @click="tabDelClick(item, scope1.$index, ix)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="number" align="center" label="发货件数" width="70">
              <template slot-scope="scope1">
                <el-input v-model="scope1.row.number" @input="changeJianShu(scope1.row, scope1.row.number)"
                  v-number-input.float="0" maxlength="50" placeholder="请输入件数" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="allWeight" align="center" label="重量（吨）" formatter="" >
              <template slot-scope="scope1">
                <el-input v-model="scope1.row.allWeight" v-number-input.float="3" maxlength="50" placeholder="请输入重量"
                  size="mini" :disabled='scope1.row.disWeight' @blur="weightInput(scope1.row, scope1.row.allWeight)">
                </el-input>
              </template>
            </el-table-column>
            <el-table-column prop="productName" align="center" label="货物类型"   ></el-table-column>
            <el-table-column prop="placeOfOrigin" align="center" label="产地"   ></el-table-column>
            <el-table-column prop="specification" align="center" label="规格"   > </el-table-column>

            <el-table-column prop="model" align="center" label="材质" >
              <template slot-scope="scope">
                <div>
                  <span v-if="scope.row.model.includes('500')" style="color:red">{{ scope.row.model }}</span>
                  <span v-else>{{ scope.row.model }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="warehouseName" align="center" label="仓位"    ></el-table-column>
            <el-table-column  prop="locationName" label="区位" align="center" 
             ></el-table-column>
            <el-table-column prop="stockAvailableNumber" align="center" label="仓位可提件数" ></el-table-column>
            <el-table-column prop="availableNumber" align="center" label="可计划件数" ></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="footerBox">
        <el-button type="primary" @click="addPlanClose">取消</el-button>
        <el-button type="primary" @click="finishClick(1)" :loading='addLoading'>保存</el-button>
        <!-- <el-button type="primary" :loading="confirmLoadingB" @click="finishClick(2)" >保存并打印</el-button> -->
      </div>
      <el-drawer title="仓位库存" :modal-append-to-body="false" size="80%" :visible.sync="addPlanTwoVisible" :modal="false"
        :before-close="addPlanClose" class="rightDrawer" >
        <div style="margin:62px 0 0 10px;" :style="{ height: h }">
          <el-table size="mini"  :data="detailsDataCopyAdd" height="100%" ref="detailsDataCopyAdd" style="width:100%;"
            :header-cell-style="{ background: '#f5f5f5' }" border @row-click="dianjixuanzhong" highlight-current-row>
            <el-table-column prop="stockAvailableNumber" align="center" label="仓位可提件数" ></el-table-column>
            <el-table-column prop="productName" align="center" label="货物类型" ></el-table-column>

            <el-table-column prop="placeOfOrigin" align="center" label="产地" ></el-table-column>
            <el-table-column prop="specification" align="center" label="规格" ></el-table-column>
            <el-table-column prop="model" align="center" label="材质" ></el-table-column>

            <el-table-column prop="warehouseName" align="center" label="仓位" ></el-table-column>
            <el-table-column  prop="locationName" label="区位" align="center"  
              ></el-table-column>
            <!-- <el-table-column prop="availableNumber" align="center" label="可计划件数"></el-table-column> -->
          </el-table>
        </div>
      </el-drawer>

    </el-drawer>
  </div>
</template>

<script>
import {
  getTEmptyBillDriverList, // 取得人车信息
  getEmptyBillStockWarehouse, // 添加出库计划 添加仓位
  JfvirtualControlBean, // 调用控货接口
  getWeighingMethodList, // 判断计重方式
  JfgetTEmptyStockCustomerGroup,
  addEmptyOutstockExp, // 添加出库计划确定
  JfaddEmptyOutstockJanFaForBill // 添加出库计划确定
} from '@/api/wms-stock.js'

const vhsrule =
  /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DF]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/
const idrule = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/
const phonerule = /^[1]([3-9])[0-9]{9}$/

export default {
  components: {},
  name: 'XinzengTidan',
  data() {
    return {
      subTableData: [],
      detailsDataCopyAdd: [],
      billId: '',
      chePai: '',

      plateNumberOption: [],
      xuanzhongArr: null,
      primaryCustomerTaxId: '',
      secondaryCustomerTaxId: '',
      organizationId: '',
      allDataList: [],
      searchArr: [],
      parentData: {},
      jianShuArr: [],
      addLoading: false,
      confirmLoadingB: false,
      paramsObject: {}
    }
  },
  props: {
    addPlanTwoVisible: {
      type: Boolean,
      default: true
    },
    planData: {
      type: Object
    },
    chePai: {
      type: String
    }
  },
  watch: {
    planData: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.parentData = val
          this.primaryCustomerTaxId = val.primaryCustomerTaxId
          this.secondaryCustomerTaxId = val.secondaryCustomerTaxId
          this.billId = val.billId
          this.organizationId = val.organizationId
        }
      }
    }
  },
  created() {
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.finishClick(2)
      }
    }
  },
  mounted() {
    this.getDriverList()
    this.driverData()
    this.getEmptyBillStockWarehouse()
   
    let pH = document.documentElement.clientHeight
    this.h = 0.85 * pH + 'px'
    console.log(pH,'11111')
  },
  methods: {
    driverData() {
      let obj = {
        plateNumber: '',
        driverName: '',
        idNumber: '',
        telephone: '',
        billDriverId: ''
      }
      this.subTableData.push(obj)
    },
    // 点击
    dianjixuanzhong(row) {
      console.log(row, 'row')
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
      this.xuanzhongArr.primaryCustomerTaxId = this.primaryCustomerTaxId
      this.xuanzhongArr.customerTaxId = this.secondaryCustomerTaxId
      this.xuanzhongArr.stockCustomerId = row.stockCustomerId
      this.JfvirtualControlBean()
      this.getWeighingMethod()
      // this.JfgetTEmptyStockCustomerGroup()
    },
    delClick(item, ix) {
      this.allDataList.splice(ix, 1)
      // this.allDataList =[]
    },
    tabDelClick(item, ix, index) {
      item.list.forEach((item1, index1) => {
        if (index1 == ix) {
          item.list.splice(ix, 1)
          if (item.list.length == 0) {
            item.num = 0
            item.sumWeight = 0
            this.delClick(item, index)
          } else {
            this.allDataList.forEach((item, index) => {
              this.$set(item, 'num', item.list.reduce((pre, cur) => {
                return pre / 1 + cur.number / 1
              }, 0))
              this.$set(item, 'sumWeight', (item.list.reduce((pre, cur) => {
                return pre / 1 + cur.allWeight / 1
              }, 0)).toFixed(3))
            })
          }
        }
      })
    },
    // 添加出库计划取消
    addPlanClose() {
      this.$emit('update:addPlanTwoVisible', false)
      this.$parent.getSeatchData()
    },
    // 出库提单 取得人车信息
    getDriverList() {
      getTEmptyBillDriverList({
        billId: this.billId
      }).then(res => {
        res.forEach(item => {
          this.plateNumberOption.push(item)
          if (this.chePai) {
            this.subTableData[0].plateNumber = this.chePai
          } else {
            this.subTableData[0].plateNumber = this.parentData.plateNumber.split(',')[0]
          }
          this.plateNumberOption.forEach(item => {
            if (this.subTableData[0].plateNumber == item.plateNumber) {
              this.subTableData[0].idNumber = item.idNumber
              this.subTableData[0].telephone = item.telephone
              this.subTableData[0].driverName = item.driverName
              this.subTableData[0].billDriverId = item.billDriverId
              console.log(this.subTableData[0].billDriverId, 'this.subTableData[0].billDriverId')
            }
          })
        })
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 提货车号下拉框值改变
    plateNumChange(row, val) {
      if (val) {
        this.plateNumberOption.forEach((item) => {
          if (val == item.plateNumber) {
            this.subTableData[0].driverName = item.driverName
            this.subTableData[0].idNumber = item.idNumber
            this.subTableData[0].telephone = item.telephone
            this.subTableData[0].billDriverId = item.billDriverId
            console.log(row.billDriverId, 'row.billDriverId')
          }
        })
      } else {
        row.driverName = ''
        row.idNumber = ''
        row.telephone = ''
      }
    },
    // 获取添加货物列表
    // 获取右边列表
    getEmptyBillStockWarehouse() {
      getEmptyBillStockWarehouse({
        billId: this.billId // （出库提单id  必填）
        // specification: this.specification, // （规格 非必填）
        // primaryCustomerTaxId: this.primaryCustomerTaxId,
        // customerTaxId: this.secondaryCustomerTaxId,
      }).then(res => {
        this.detailsDataCopyAdd = res
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 判断计重方式
    getWeighingMethod() {
      getWeighingMethodList({
        productType: this.xuanzhongArr.productType
      }).then(res => {
        if (res[0].outWeighingMethod == 1) {
          this.$set(this.xuanzhongArr, 'disWeight', true)
        } else {
          this.$set(this.xuanzhongArr, 'disWeight', false)
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 获取单件理重
    JfgetTEmptyStockCustomerGroup() {
      JfgetTEmptyStockCustomerGroup({
        primaryCustomerTaxId: this.primaryCustomerTaxId, // （一级货主id  必填）
        customerTaxId: this.secondaryCustomerTaxId, // （二级货主id 必填）
        productType: this.xuanzhongArr.productType, // （货物类型id  非必填）
        steelMillName: this.xuanzhongArr.steelMillName, // （产地  非必填）
        model: this.xuanzhongArr.model, // （材质 非必填）
        specification: this.xuanzhongArr.specification // （规格  非必填）
      }).then(res => {
        this.$set(this.xuanzhongArr, 'singletonWeight', res[0].singletonWeight)
        this.$set(this.xuanzhongArr, 'stockCustomerId', res[0].stockCustomerId)
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 调用控货接口
    JfvirtualControlBean() {
      JfvirtualControlBean({
        oneCustomerTaxId: this.primaryCustomerTaxId, // （一级货主纳税人识别号  必填）
        twoCustomerTaxId: this.secondaryCustomerTaxId, // （二级货主纳税人识别号  必填）
        organizationId: this.organizationId, // （仓储租户id  必填）
        productionPlaceName: this.xuanzhongArr.placeOfOrigin, // （产地  必填）
        specificationName: this.xuanzhongArr.specification, // （规格  必填）
        materialName: this.xuanzhongArr.model, // （材质  必填）
        goodTypeName: this.xuanzhongArr.productName // （货物类型名称  必填
      }).then(res => {
        console.log(JSON.parse(res), 'res')
        // controlPiece: 1  // 控件  0不控  1控
        // controlWeight: 1 // 控吨  0不控  1控
        // isEnable: 1    //控货不控货标识   1控  2不控
        if (res) {
          let isEnableObj = {}
          isEnableObj = JSON.parse(res)
          this.$set(this.xuanzhongArr, 'number', '')
          this.$set(this.xuanzhongArr, 'weight', '')
          this.$set(this.xuanzhongArr, 'allWeight', '')
          this.$set(this.xuanzhongArr, 'productTypeName', this.xuanzhongArr.productName)
          this.$set(this.xuanzhongArr, 'billDetailId', this.xuanzhongArr.billDetailId)
          // 控货
          if (isEnableObj.isEnable == '1') {
            // let str = `${isEnableObj.productionPlaceName ? isEnableObj.productionPlaceName : '_'}${isEnableObj.goodTypeName ? isEnableObj.goodTypeName : '_'}${isEnableObj.specificationName ? isEnableObj.specificationName : '_'}${isEnableObj.materialName ? isEnableObj.materialName : ''}`
            let str = (isEnableObj.productionPlaceName ? isEnableObj.productionPlaceName : '') + ',' +
              (isEnableObj.goodTypeName ? isEnableObj.goodTypeName : '') + ',' +
              (isEnableObj.specificationName ? isEnableObj.specificationName : '') + ',' +
              (isEnableObj.materialName ? isEnableObj.materialName : '')

            console.log(str, 'str')
            if (str == ',,,') {
              str = '总控'
            }
            this.$set(this.xuanzhongArr, 'cargoControlKey', str)
            if (this.allDataList.some(item => item.cargoControlKey == str)) {
              let index = this.allDataList.findIndex(item => item.cargoControlKey == str)
              this.allDataList[index].list.push(this.xuanzhongArr)
              this.allDataList[index].list = Array.from(new Set(this.allDataList[index].list))
            } else {
              let obj = {
                cargoControlKey: str,
                releaseFlag: 0,
                list: [],
                num: 0,
                sumWeight: 0,
                surplus: true,
                surplusControlWeight: isEnableObj.surplusControlWeight,
                surplusControlNumber: isEnableObj.surplusControlNumber,
                controlWeight: isEnableObj.controlWeight,
                controlPiece: isEnableObj.controlPiece,
                strictReminder: isEnableObj.strictReminder,
                isEnable: isEnableObj.isEnable
              }
              obj.list.push(this.xuanzhongArr)
              this.allDataList.push(obj)
            }
            console.log(this.allDataList, 'this.allDataList')
          } else {
            // 不控
            this.$set(this.xuanzhongArr, 'cargoControlKey', '不控货')
            if (this.allDataList.some(item => item.cargoControlKey == '不控货')) {
              let index = this.allDataList.findIndex(item => item.cargoControlKey == '不控货')
              this.allDataList[index].list.push(this.xuanzhongArr)
              this.allDataList[index].list = Array.from(new Set(this.allDataList[index].list))
            } else {
              let obj = {
                cargoControlKey: '不控货',
                list: [],
                num: 0,
                sumWeight: 0,
                surplus: false
              }
              obj.list.push(this.xuanzhongArr)
              this.allDataList.push(obj)
            }
            console.log(this.allDataList, 'this.allDataList')
          }
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    changeJianShu(row, val) {
      if (val) {
        this.$set(row, 'weight', (row.number / 1 * row.singletonWeight).toFixed(3))
        this.$set(row, 'allWeight', (row.number / 1 * row.singletonWeight).toFixed(3))
      } else {
        this.$set(row, 'weight', '0.000')
        this.$set(row, 'allWeight', '0.000')
      }
      // console.log(row, val)
      // console.log(this.allDataList, 'this.allDataList')
      this.allDataList.forEach((item, index) => {
        this.$set(item, 'num', item.list.reduce((pre, cur) => {
          return pre / 1 + cur.number / 1
        }, 0))
        this.$set(item, 'sumWeight', (item.list.reduce((pre, cur) => {
          return pre / 1 + cur.allWeight / 1
        }, 0)).toFixed(3))
      })
    },
    weightInput(row, val) {
      row.allWeight = Number(val).toFixed(3)
      this.allDataList.forEach(item => {
        this.$set(item, 'num', item.list.reduce((pre, cur) => {
          return pre / 1 + cur.number / 1
        }, 0))
        this.$set(item, 'sumWeight', (item.list.reduce((pre, cur) => {
          return pre / 1 + cur.allWeight / 1
        }, 0)).toFixed(3))
      })
    },
    idInput(val) {
      if (val != '' && !idrule.test(val)) {
        this.$message({
          message: '请输入正确的身份证号',
          type: 'error'
        })
      }
    },
    phoneInput(val) {
      if (val != '' && !phonerule.test(val)) {
        this.$message({
          message: '请输入正确的手机号',
          type: 'error'
        })
      }
    },
    finishClick(n) {
      if (this.allDataList.length == 0) {
        this.$message.error('请选择右侧数据填写货物信息再点击保存')
      } else {
        let noValidate = this.subTableData.some(item => item.vhcNo == '')
        let driverNameValidate = this.subTableData.some(item => item.driverName == '')

        // let chepai = this.subTableData.some(item => !vhsrule.test(item.plateNumber))
        let idCard = this.subTableData.some(item => !idrule.test(item.idNumber) && item.idNumber != '')
        let phoneCard = this.subTableData.some(item => !phonerule.test(item.telephone) && item.telephone != '')
        if (noValidate) {
          this.$message({ message: '提货车号不能为空', type: 'error' })
          this.addLoading = false
          return
        } else if (driverNameValidate) {
          this.$message({ message: '司机姓名不能为空', type: 'error' })
          this.addLoading = false
          return
        } else if (idCard) {
          this.$message({
            message: '身份证号不正确',
            type: 'error'
          })
        } else if (phoneCard) {
          this.$message({
            message: '手机号不正确',
            type: 'error'
          })
        } else {
          let flagA = this.allDataList.every(item => item.num / 1 != 0)
          if (!flagA) {
            this.$message.error('件数不能为空或0')
            return
          }
          let flagB = true
          this.allDataList.forEach(item => {
            flagB = item.list.every(im => !!im.number || !!im.allWeight)
          })
          if (!flagB) {
            this.$message.error('信息填写不完整')
            return
          }
          if (flagA && flagB) {
            if (this.subTableData[0].billDriverId == '' || this.subTableData[0].billDriverId == null || this
              .subTableData[0].billDriverId == undefined) {
              this.$message.error('非提单维护的完整车牌号不能保存')
            } else {
              this.paramsObject = {
                billId: this.billId,

                tEmptyOutstockMaster: {
                  billId: this.billId,
                  primaryCustomerName: this.planData.primaryCustomerName, // （一级货主名称  必填）
                  primaryCustomerTaxId: this.planData.primaryCustomerTaxId, // （一级货主id  必填）
                  customerName: this.planData.secondaryCustomerName, // （二级货主名称  必填）
                  customerTaxId: this.planData.secondaryCustomerTaxId, // （二级货主id 必填）
                  outstockPlateNumber: this.subTableData[0].plateNumber, // （出库车牌号  必填）
                  outBillNo: this.planData.outBillNo, // （客户单号 必填 来源提单主表）
                  billDriverId: this.subTableData[0].billDriverId, // （提单司机id 必填）
                  driverName: this.subTableData[0].driverName, // （司机姓名  必填）
                  carHoldFalg: this.planData.carHoldFalg, // （扣车标记 0：不扣，1：扣车 必填）
                  telephone: this.subTableData[0].telephone, // （司机手机 非必填）
                  idNumber: this.subTableData[0].idNumber, // （身份证号 非必填）
                  remark: this.planData.remark // （出库单备注 非必填）
                },
                list: this.allDataList[0].list
              }
              this.recursionCheck(0, n)

              console.log(this.paramsObject, 'this.paramsObject')
              // addEmptyOutstockExp(this.paramsObject).then(res => {
              //   this.$set(this.xuanzhongArr, 'singletonWeight', res[0].singletonWeight)
              // }).catch(err => {
              //   this.$message.error(err.message)
              // })
            }
          }
        }
      }
    },
    // 调接口
    addOutStock(n) {
      if (n == '1') {
        this.addLoading = true
      } else {
        this.confirmLoadingB = true
      }
      addEmptyOutstockExp(this.paramsObject).then(res => {
        if (n == '1') {
          this.addLoading = false
          this.$emit('update:addPlanTwoVisible', false)
          this.$message.success('添加成功')
          this.addPlanClose()
          this.$emit('getTime')
        } else {
          this.confirmLoadingB = false
          this.$emit('update:addPlanTwoVisible', false)
          this.$message.success('添加成功')
          this.addPlanClose()
          // this.$router.push({
          //   path: '/zhuangcheDanPrint',
          //   query: {
          //     id: res
          //   }
          // })
        }
      }).catch(err => {
        if (n == '1') {
          this.addLoading = false
        } else {
          this.confirmLoadingB = false
        }
        if (err.code == '-200') {
          this.$message.error(JSON.parse(err.message).msg)
          let cargoControlKey = JSON.parse(err.message).cargoControlKey
          if (cargoControlKey != '不控货') {
            let paramsObj = {}
            if (cargoControlKey == '总控') {
              paramsObj = {
                oneCustomerTaxId: this.primaryCustomerTaxId, // （一级货主纳税人识别号  必填）
                twoCustomerTaxId: this.secondaryCustomerTaxId, // （二级货主纳税人识别号  必填）
                organizationId: this.organizationId // （仓储租户id  必填）
              }
            } else {
              let controlKeyArr = cargoControlKey.split(',')
              paramsObj = {
                oneCustomerTaxId: this.primaryCustomerTaxId, // （一级货主纳税人识别号  必填）
                twoCustomerTaxId: this.secondaryCustomerTaxId, // （二级货主纳税人识别号  必填）
                organizationId: this.organizationId, // （仓储租户id  必填）
                productionPlaceName: controlKeyArr[0], // （产地  必填）
                goodTypeName: controlKeyArr[1], // （货物类型名称  必填
                specificationName: controlKeyArr[2], // （规格  必填）
                materialName: controlKeyArr[3] // （材质  必填）
              }
            }
            JfvirtualControlBean(paramsObj).then(res => {
              let isEnableObjB = JSON.parse(res)
              for (let index = 0; index < this.allDataList.length; index++) {
                console.log(this.allDataList[index], 'this.allDataList[index]')
                if (this.allDataList[index].cargoControlKey == cargoControlKey) {
                  this.allDataList[index].surplusControlWeight = isEnableObjB.surplusControlWeight
                  this.allDataList[index].surplusControlNumber = isEnableObjB.surplusControlNumber
                }
              }
            }).catch(err => {
              this.$message.error(err.message)
            })
          }
        } else {
          this.$message.error(err.message)
        }
      })
    },
    // 递归调用
    recursionCheck(index, n) {
      console.log('asdfasdfads', index)
      if (index < 0) {
        return
      }
      if (index == this.allDataList.length) {
        this.addOutStock(n)
      }
      if (index > this.allDataList.length) {
        // todo
      }
      const item = this.allDataList[index]
      // if (item) {
      if (item.isEnable == '1') {
        // 严控
        if (item.strictReminder == '0') {
          if (item.controlPiece == '1' && item.controlWeight == '1') {
            if (item.num > item.surplusControlNumber || item.sumWeight > item.surplusControlWeight) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的数据大于货权剩余量')
            } else {
              this.recursionCheck(index + 1, n)
            }
          } else if (item.controlPiece == '1') { // 控件
            if (item.num > item.surplusControlNumber) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的件数大于货权剩余量')
            } else {
              this.recursionCheck(index + 1, n)
            }
          } else if (item.controlWeight == '1') { // 控吨
            if (item.sumWeight > item.surplusControlWeight) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的重量大于货权剩余量')
            } else {
              this.recursionCheck(index + 1, n)
            }
          }
        } else {
          console.log('提示')
          // 提示
          if (item.controlPiece == '1') {
            if (item.num > item.surplusControlNumber) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的件数大于货权剩余量')
              return
            }
          }
          if (item.controlWeight == '1') {
            console.log('控吨')

            if (item.sumWeight > item.surplusControlWeight) {
              this.$confirm((item.cargoControlKey).replace(/,/g, '') + '所输入的重量大于货权剩余量，是否继续', '提示', {
                confirmButtonText: '继续',
                cancelButtonText: '取消',
                closeOnClickModal: false,
                type: 'warning'
              }).then(() => {
                item.releaseFlag = 1
                console.log(item.cargoControlKey, item.releaseFlag)
                this.recursionCheck(index + 1, n)
              }).catch(() => { })
            } else {
              this.recursionCheck(index + 1, n)
            }
          } else {
            this.recursionCheck(index + 1, n)
          }
        }
      } else {
        this.addOutStock(n)
      }
      // }
    }
  }
}

</script>

<style lang="scss" scoped>
// .el-table .cell {
//    white-space: nowrap;
//     overflow: hidden;
//     text-overflow: ellipsis;
// }
</style>>

</style>
